<template>
  <div
    class="wechat"
    v-if="showWx"
  >
    <div class="wc">
      请在微信APP内打开该页面
    </div>
  </div>
</template>
    
  <script>
export default {
  name: "wechat",
  data: function () {
    return {
      showWx: false,
    };
  },
  mounted: function () {
    if (!this.$xh.isWeChat()) {
      this.showWx = true;
    }
  },
};
</script>
    
<style scoped lang="scss">
.wechat {
  width: 100vw;
  height: 100vh;
  background: rgba($color: #000000, $alpha: 0.6);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  .wc {
    width: 6.6rem;
    height: 1.68rem;
    background: #ffffff;
    color: #000000;
    font-size: 0.29rem;
    text-align: center;
    line-height: 1.68rem;
  }
}
</style>